export enum FormTypeEnum {
  jump = "jumpmenu_id",
  menu = "MenuItemID",
  resource = "ResourceId",
}
